<div class="flex justify-between items-center">

    <div class="flex justify-start items-center">
        <!-- @if(shouldShowBackButton()) {
        <app-button label="Back to Dashboard" variant="text" startIcon="/icons/arrow-left.svg"
            (onClick)="redirectToDashboard()" />
        } -->
    </div>
    <div class="flex">
        <div class="flex gap-(--spacing-layout-m)">
            @if (shouldShowRequestSpecificDealButton()) {
            <app-button label="Request specific deal" variant="primary" endIcon="/icons/briefcase-deal.svg" (onClick)="onRequestSpecificDeal()" />
            }
            <div class="flex items-center justify-center relative cursor-pointer"
                (click)="onBellClick($event)">
                @if (getUnreadCount() > 0) {
                <p-overlaybadge value="{{ getUnreadCount().toString() }}" badgeSize="small" size="small"
                    severity="danger">
                    <svg-icon src="/icons/bell_icon.svg" svgClass="w-6 h-6"></svg-icon>
                </p-overlaybadge>
                } @else {
                <svg-icon src="/icons/bell_icon.svg" svgClass="w-6 h-6"></svg-icon>
                }
            </div>

            <app-popover #notificationPopover header="Notifications" [showCloseButton]="false"
                [isNotificationPopover]="true" (onMarkAllAsRead)="markAllAsRead()" [isShowMarkAllAsRead]="hasUnreadStatusZero()" >
                <ng-template #content>
                    <div class="flex flex-col max-w-[400px] max-h-[600px] overflow-y-auto gap-(--spacing-layout-m)">

                        <!-- Notifications List -->
                        <div
                            class="notification-popover-list flex flex-col gap-(--spacing-layout-m) max-h-[400px] overflow-y-auto">
                            @if (_notificationsService.notificationsSummaryLoading()) {
                            <div class="flex flex-col gap-(--spacing-layout-m)">
                                <p-skeleton height="60px" class="mb-2"></p-skeleton>
                                <p-skeleton height="60px" class="mb-2"></p-skeleton>
                                <p-skeleton height="60px"></p-skeleton>
                            </div>
                            } @else if (getMappedNotifications().length > 0) {
                            @for (notification of getMappedNotifications(); track notification.id) {
                            <app-notification-item [title]="notification.title" [message]="notification.message"
                                [type]="notification.type" [actionButton]="notification.actionButton"
                                (onClick)="onNotificationClick(notification)"
                                (onDismiss)="onNotificationDismiss(notification)"
                                (onActionClick)="onNotificationAction(notification.id)" />
                            }
                            } @else {
                            <div class="flex flex-col items-center justify-center gap-(--spacing-layout-m) p-12">
                                <svg-icon src="/icons/bell-outlined.svg" svgClass="w-6 h-6 text-bodyText"></svg-icon>
                                <p class="text-subheading-large text-bodyText">No
                                    notifications available</p>
                            </div>
                            }
                        </div>

                        <!-- Footer -->
                        <div class="flex justify-center">
                            <app-button label="View all" variant="primary" size="large" [fluid]="true"
                                (onClick)="viewAllNotifications()" />
                        </div>
                    </div>
                </ng-template>
            </app-popover>
            
        </div>
        <div class="flex items-center">
            @if (_userProfileService.userProfileLoading()) {
            <div class="hidden sm:flex flex-col items-start justify-center cursor-pointer">
                <p-skeleton shape="circle" size="35px" />
            </div>
            } @else {
            <div class="cursor-pointer" (click)="profilePopover.toggle($event)">
                <app-avatar [image]="_userProfileService.userProfileData()?.profilePictureUrl"
                    [icon]="_userProfileService.userProfileData()?.profilePictureUrl ? undefined : 'pi pi-user'"
                    [initials]="_userProfileService.userProfileData()?.profilePictureUrl ? undefined : getInitials()"
                    size="small" shape="circle" />
            </div>
            <app-popover #profilePopover [items]="getProfileMenuItems()" [showCloseButton]="false" />
            }
        </div>
    </div>
</div>

<!-- Popup Dialogs -->
@if(showRequestDealDialog()) {
<app-request-deal-dialog [(visible)]="showRequestDealDialog" (onSubmitSuccess)="onRequestDealSuccess()" />
}

@if(showContactRmDialog()) {
<app-contact-rm-dialog [(visible)]="showContactRmDialog" (onSuccess)="onContactRmSuccess()" />
}
